import { render, staticRenderFns } from "./WizardRenewedComponent.vue?vue&type=template&id=306b5277"
import script from "./WizardRenewedComponent.vue?vue&type=script&lang=js"
export * from "./WizardRenewedComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports